import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { MentorQueuesData } from "../../types";
import { loadActiveMentors } from "../../redux/actions/guideStreamActions";
import ActiveQueueTable from "./ActiveQueueTable";
import Loading from "../../../Shared/loading";
import useInterval from "../../../Shared/useInterval";

const mapState = ({ localizations, activeMentors, apiCallsInProgress }: MentorQueuesData) => ({
    activeMentors,
    localizations: localizations!,
    apiCallsInProgress,
});

const mapDispatch = {
    loadActiveMentors,
};
const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;
type PropTypes = PropsFromRedux & {};

function ActivePage({ activeMentors, loadActiveMentors, localizations, apiCallsInProgress }: PropTypes) {
    // const { queuedMentors, loadQueuedMentors } = props;
    useEffect(() => {
        if (activeMentors.length === 0) {
            loadActiveMentors();
        }
    }, []);

    const [secondsUntilRefresh, updateSecondsUntilRefresh] = useState(30);

    useInterval(() => {
        if (secondsUntilRefresh === 0) {
            loadActiveMentors();
            updateSecondsUntilRefresh(30);
        } else {
            updateSecondsUntilRefresh(secondsUntilRefresh - 1);
        }
    }, 1000);

    const refreshNow = () => {
        loadActiveMentors();
        updateSecondsUntilRefresh(30);
    };

    return (
        <>
            {apiCallsInProgress > 0 ? (
                <>
                    <Loading message={localizations.loadingMentors} />
                </>
            ) : (
                <ActiveQueueTable
                    refreshNow={refreshNow}
                    refreshTimer={secondsUntilRefresh}
                    activeMentors={activeMentors}
                    localizations={localizations}
                />
            )}
        </>
    );
}

export default connector(ActivePage);
